import { render, staticRenderFns } from "./AdminUsers.vue?vue&type=template&id=56bd144e&scoped=true"
import script from "./AdminUsers.vue?vue&type=script&lang=ts"
export * from "./AdminUsers.vue?vue&type=script&lang=ts"
import style0 from "./AdminUsers.vue?vue&type=style&index=0&id=56bd144e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56bd144e",
  null
  
)

export default component.exports